import { IonFooter, IonModal, IonText } from "@ionic/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { usePostHog } from "posthog-js/react";
import { Button } from "@/components/Global/Button";
import { Toolbar } from "@/components/Global/Toolbar";
import { ReflectionProgress } from "@/components/Reflection/Progress";
import { useMyProgression } from "@/lib/query/functions/user/progression";
import { useSelectorModalStore } from "@/lib/store/modal";

export function ModalReflectionCompleted() {
	const { t } = useTranslation();
	const posthog = usePostHog();
	const modalRef = useRef<HTMLIonModalElement>(null);
	const modal = useSelectorModalStore.use.reflectionCompleted();
	const present = useSelectorModalStore.use.present();
	const dismiss = useSelectorModalStore.use.dismiss();
	const [myProgression] = useMyProgression();

	return (
		<IonModal
			ref={modalRef}
			isOpen={modal.isOpen}
			onWillPresent={() => {
				present("reflectionCompleted");
				posthog.capture("Modal Reflection Completed Present");
			}}
			onWillDismiss={() => {
				dismiss("reflectionCompleted");
				posthog.capture("Modal Reflection Completed Dismiss");
			}}
			initialBreakpoint={1}
			breakpoints={[0, 1]}
			className="ion-h-auto ion-rounded-4xl"
		>
			<div className="ion-padding mt-4 flex flex-col gap-2 pt-12">
				<IonText className="text-brown-700 text-2xl font-bold">
					{t("modal.reflection.completed.title")}
				</IonText>

				<ReflectionProgress withAction={false} className="pointer-events-none" />
			</div>

			<IonFooter className="ion-no-border">
				<Toolbar className="ion-bg-brown-200 ion-p-4">
					<div className="flex flex-col gap-2">
						<Button
							data-attr="modal.reflection.completed.confirm"
							expand="block"
							variant="primary"
							onClick={() => {
								present(
									myProgression.reflection === "COMPLETED_ALL"
										? "reflectionAnalysisView"
										: "reflectionAnalysisGenerate",
								);
								posthog.capture("Modal Reflection Completed Finished");
								modalRef.current?.dismiss();
							}}
						>
							{t("modal.reflection.completed.confirm")}
						</Button>
					</div>
				</Toolbar>
			</IonFooter>
		</IonModal>
	);
}
